import { useEffect } from 'react';
import logger from 'lc-logger';
import appConfig from 'lc-app-config';
import WebsiteComponent from '../../components/websiteComponent/websiteComponent';
import csrf from '../../services/helpers/csrf';
import render404Page from '../../services/helpers/render404Page';
import LandingPagesService from '../../services/landing-pages';
import styles from '../../styles/main.module.scss';
import helpStyles from '../../styles/help.module.scss';
import LcResources from '../../components/lcResources/lcResources';
import trackHeapEvent from '../../services/helpers/trackHeapEvent';
import { getOptimizelyUserExperiments } from '../../services/helpers/common';

export default function Page({ components, lcResources, experiments }) {
  useEffect(() => {
    trackHeapEvent(
      {
        Title: 'Page Load',
        Page: 'Help Home page',
      },
      `CMS_Unification`,
      experiments
    );
  }, [experiments]);
  return (
    <main className={styles.main}>
      <div className={styles.landingPage}>
        <div className={styles.components}>
          {components.map((component, index) => {
            const key = `${component.type}-${index}`;

            return (
              <div key={key} id={component.id ?? key}>
                <WebsiteComponent {...component} />
              </div>
            );
          })}
        </div>
      </div>
      {lcResources && (
        <div
          className={`${styles.container} ${helpStyles.lcResourcesContainer}`}
          id="Resources"
        >
          <div className={styles.section}>
            <LcResources
              title="LendingClub Resources"
              lcResources={lcResources}
            />
          </div>
        </div>
      )}
    </main>
  );
}

export async function getServerSideProps(context) {
  const slug = `help`;
  const userVariation = getOptimizelyUserExperiments(context.req.headers);

  const landingPagesService = new LandingPagesService(context.preview);
  const props = await landingPagesService.getPageTemplateBySlug(
    slug,
    userVariation
  );
  if (!props) {
    logger.info(
      {
        statusCode: 404,
        slug,
      },
      `LC-WEBSITE: Page not found for Slug`
    );
    return render404Page(context);
  }
  logger.info(
    {
      statusCode: 200,
      slug,
    },
    `LC-WEBSITE: Generating page for Slug`
  );

  const spaceId = appConfig.get('CONTENTFUL_SPACE_ID');
  const csrfToken = await csrf(context.req, context.res);
  return {
    props: {
      ...props,
      isPreview: !!context.preview,
      spaceId,
      csrfToken,
      experiments: Object.fromEntries(userVariation),
    },
  };
}
